import { LangDefinition } from '@jsverse/transloco';

export class Languages {
  static readonly availableLanguages: LangDefinition[] = [
    {
      id: 'ar-SA',
      label: 'العربية',
    },
    {
      id: 'de-DE',
      label: 'Deutsch',
    },
    {
      id: 'da-DK',
      label: 'Dansk',
    },
    {
      id: 'en-GB',
      label: 'English',
    },
    {
      id: 'es-ES',
      label: 'Español',
    },
    {
      id: 'fr-FR',
      label: 'Français',
    },
    {
      id: 'hr-HR',
      label: 'Hrvatski',
    },
    {
      id: 'it-IT',
      label: 'Italiano',
    },
    {
      id: 'nb-NO',
      label: 'Norsk',
    },
    {
      id: 'ru-RU',
      label: 'Русский',
    },
    {
      id: 'sr-Latn',
      label: 'Srpski',
    },
    {
      id: 'sv-SE',
      label: 'Svenska',
    },
  ];
}
